/**
 * BaseControl - базовый класс поведения
 * дефолт: prefix: "bb-", installed: "-installed"
 *
 */
export abstract class BaseControlBehaviour {
    private prefix = 'bb-';
    readonly installed: string = '-installed';

    protected tag: string;
    protected tagInstalled: string;
    protected name: string;
    protected options: IControlsOptions;

    constructor(name: string) {
        this.tag = this.getPrefix() + name;
        this.tagInstalled = this.tag + this.installed;
        this.name = name;
    }

    public getBehaviorName(): string {
        return this.name;
    }

    protected getPrefix(): string {
        return this.prefix;
    }

    protected getFullTag(): string {
        return this.tag;
    }

    public shouldInstall(element: any): boolean {
        return (
            $(element).is(
                '[' + this.tag + ']:not([' + this.tagInstalled + '])'
            ) && this.installCondition(element)
        );
    }

    protected installCondition(element: any): boolean {
        return true;
    }

    protected getBehaviorValue(element: any): string {
        return $(element).attr(this.tag);
    }

    protected setInstalled(element: any): void {
        if (!$(element).attr(this.tagInstalled)) {
            $(element).attr(this.tagInstalled, 'true');
        }
    }

    protected abstract installBehaviour(element: HTMLElement): void;
    public install(element: any, opts?: IControlsOptions): void {
        this.options = opts;
        this.installBehaviour(element);
        this.setInstalled(element);
    }
}

/**
 * BaseEmptyPrefixControl - базовый класс поведения c переопределенным префиксом = ""
 * дефолт: prefix: "", installed: "-installed"
 *
 */
export abstract class BaseEmptyPrefixControlBehaviour extends BaseControlBehaviour {
    constructor(attr: string) {
        super(attr);
    }

    protected getPrefix(): string {
        return '';
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.BaseControlBehaviour = BaseControlBehaviour;
window.Behaviours.BaseEmptyPrefixControlBehaviour = BaseEmptyPrefixControlBehaviour